import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface AuthenticationRequiredProps {
  message: string;
  returnPath: string;
}

const AuthenticationRequired = ({ message, returnPath }: AuthenticationRequiredProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogin = () => {
    // Store the return path in session storage
    sessionStorage.setItem("returnPath", returnPath);
    navigate("/");
    toast({
      title: "Authentication Required",
      description: message,
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-background">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle>Authentication Required</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">{message}</p>
          <Button onClick={handleLogin} className="w-full">
            Continue to Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthenticationRequired;